module.exports = __webpack_public_path__ + "static/media/asset3.2e8b5373.png";